export default __webpack_public_path__ + "static/media/event.0dfe649b.jpg";